(function () {
  'use strict';

  var root = document.querySelector('[data-bunk-pdp]');
  var configNode = document.querySelector('[data-bunk-pdp-config]');
  if (!root || !configNode) return;

  var cfg = JSON.parse(configNode.textContent);
  var STORAGE_KEY = 'ervp:bunk-order:v1';
  var STORAGE_TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var MAX_SAVED_BUNKS = 10;
  var editLineKey = '';
  var editingBunkId = '';
  var draftDirty = false;
  var savedBunks = [];
  var fitments = Array.isArray(cfg.fitments) && cfg.fitments.length ? cfg.fitments : (Array.isArray(window.ERVPBunkFitments) ? window.ERVPBunkFitments : []);
  fitments = fitments.map(function (fitment) {
    ['aliases', 'configurations'].forEach(function (key) {
      if (typeof fitment[key] === 'string') {
        try { fitment[key] = JSON.parse(fitment[key]); } catch (error) { fitment[key] = fitment[key] ? [fitment[key]] : []; }
      }
      if (fitment[key] && !Array.isArray(fitment[key])) fitment[key] = [fitment[key]];
      if (!fitment[key]) fitment[key] = [];
    });
    return fitment;
  });
  var selectedFitment = null;
  var selectedFitmentYear = 0;

  var atc = root.querySelector('[data-add-to-cart]');
  var saveBunk = root.querySelector('[data-save-bunk]');
  var cancelEdit = root.querySelector('[data-cancel-bunk-edit]');
  var status = root.querySelector('[data-status]');
  var canvas = root.querySelector('[data-blueprint]');
  var orderWrap = root.querySelector('[data-bunk-order]');
  var orderList = root.querySelector('[data-bunk-list]');
  var addAll = root.querySelector('[data-add-all-bunks]');
  var measurementConfirm = root.querySelector('[data-measurement-confirm]');
  var coverTexture = new Image();
  coverTexture.decoding = 'async';

  function q(selector) { return root.querySelector(selector); }
  function clone(value) { return JSON.parse(JSON.stringify(value)); }
  function money(value) { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value); }
  function cleanNumber(value) { var number = Number(value); return Number.isFinite(number) ? number : 0; }
  function fmtIn(value) { return Number.isInteger(value) ? String(value) : String(value).replace(/\.00$/, ''); }
  function trackingDetails(source) {
    source = source || state;
    return {
      product_type: source.productType === 'cover_only' ? 'cover_only' : 'mattress_and_cover',
      thickness: Number(source.thickness) || 0,
      width_bucket: source.width ? widthBucketFor(source) : '',
      length_bucket: source.length ? lengthBucketFor(source) : '',
      saved_bunk_count: savedBunks.length,
      quantity: Number(source.quantity) || 1,
      fitment_used: !!source.fitmentHandle
    };
  }
  function track(name, details) {
    var payload = Object.assign({ event: name, builder_version: cfg.builderVersion || 'bunk-pdp-v2' }, details || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    try { document.dispatchEvent(new CustomEvent('ervp:bunk-builder-event', { detail: payload })); } catch (error) { /* tracking must never block ordering */ }
  }
  function newCorners() {
    return {
      top_left: { type: 'square', angle: 45, depth: 4, cutWidth: 4, cutDepth: 4, radius: 3, notchWidth: 4, notchDepth: 4 },
      top_right: { type: 'square', angle: 45, depth: 4, cutWidth: 4, cutDepth: 4, radius: 3, notchWidth: 4, notchDepth: 4 },
      bottom_left: { type: 'square', angle: 45, depth: 4, cutWidth: 4, cutDepth: 4, radius: 3, notchWidth: 4, notchDepth: 4 },
      bottom_right: { type: 'square', angle: 45, depth: 4, cutWidth: 4, cutDepth: 4, radius: 3, notchWidth: 4, notchDepth: 4 }
    };
  }
  function newState(contact) {
    contact = contact || {};
    return {
      productType: cfg.defaultProductType === 'cover_only' ? 'cover_only' : 'mattress_and_cover',
      projectName: '',
      email: contact.email || '',
      rvMake: contact.rvMake || '',
      rvModel: contact.rvModel || '',
      rvYear: contact.rvYear || new Date().getFullYear(),
      width: 36,
      length: 72,
      thickness: 6,
      quantity: 1,
      projectId: '',
      buildId: '',
      buildSheetUrl: '',
      measurementConfirmed: false,
      fitmentHandle: '',
      fitmentTitle: '',
      fitmentSourceLabel: '',
      fitmentSourceUrl: '',
      fitmentSuggestedWidth: 0,
      fitmentSuggestedLength: 0,
      corners: newCorners()
    };
  }
  var state = newState();

  function normalizedState(source) {
    var result = newState(source || {});
    var keys = ['productType', 'projectName', 'email', 'rvMake', 'rvModel', 'rvYear', 'width', 'length', 'thickness', 'quantity', 'projectId', 'measurementConfirmed', 'fitmentHandle', 'fitmentTitle', 'fitmentSourceLabel', 'fitmentSourceUrl', 'fitmentSuggestedWidth', 'fitmentSuggestedLength'];
    keys.forEach(function (key) {
      if (source && source[key] !== undefined && source[key] !== null) result[key] = source[key];
    });
    if (source && source.corners && typeof source.corners === 'object') {
      Object.keys(result.corners).forEach(function (key) {
        if (source.corners[key]) {
          result.corners[key] = Object.assign({}, result.corners[key], source.corners[key]);
          if (source.corners[key].cutWidth === undefined) result.corners[key].cutWidth = cleanNumber(source.corners[key].depth) || 4;
          if (source.corners[key].cutDepth === undefined) result.corners[key].cutDepth = cleanNumber(source.corners[key].depth) || 4;
        }
      });
    }
    result.productType = result.productType === 'cover_only' ? 'cover_only' : 'mattress_and_cover';
    result.quantity = Math.max(1, Math.min(10, Math.round(cleanNumber(result.quantity) || 1)));
    result.thickness = cleanNumber(result.thickness) || 6;
    result.width = cleanNumber(result.width) || 36;
    result.length = cleanNumber(result.length) || 72;
    result.measurementConfirmed = result.measurementConfirmed === true;
    result.buildId = '';
    result.buildSheetUrl = '';
    return result;
  }
  function shareableState(source) {
    var copy = normalizedState(source);
    delete copy.buildId;
    delete copy.buildSheetUrl;
    return copy;
  }
  function productConfigFor(source) { return source.productType === 'cover_only' ? cfg.coverProduct : cfg.mattressProduct; }
  // Supplier whole-inch bands are 18–23, 24–39 and 40–60.
  // Keep the existing Shopify option keys; exact 24/40 enter the next band.
  function widthBucketFor(source) { return source.width < 24 ? '18-24' : source.width < 40 ? '24-40' : '40-60'; }
  function lengthBucketFor(source) { return source.length <= 59 ? '48-59' : '60-80'; }
  function variantFor(source) {
    return productConfigFor(source).variants.find(function (variant) {
      return variant.available && Number(variant.thickness) === Number(source.thickness) && variant.widthBucket === widthBucketFor(source) && variant.lengthBucket === lengthBucketFor(source);
    });
  }
  function cornerText(corner) {
    if (corner.type === 'square') return 'Square';
    if (corner.type === 'cut') return fmtIn(corner.cutWidth) + '″ along width edge × ' + fmtIn(corner.cutDepth) + '″ along length edge angled corner';
    if (corner.type === 'notch') return fmtIn(corner.notchWidth) + '″ W × ' + fmtIn(corner.notchDepth) + '″ D rectangular notch';
    return fmtIn(corner.radius) + '″ radius';
  }
  function cornerSummaryFor(source) {
    var changed = Object.keys(source.corners).filter(function (key) { return source.corners[key].type !== 'square'; });
    return changed.length ? changed.map(function (key) {
      var corner = source.corners[key], name = key.replace('_', ' ');
      name = name.charAt(0).toUpperCase() + name.slice(1);
      if (corner.type === 'cut') return name + ' angled: ' + fmtIn(corner.cutWidth) + '″ along ' + (key.indexOf('top') === 0 ? 'top' : 'bottom') + ', ' + fmtIn(corner.cutDepth) + '″ along ' + (key.indexOf('left') > -1 ? 'left' : 'right');
      return name + ': ' + cornerText(corner);
    }).join('; ') : 'All square';
  }
  // Customer diagrams use the same independent edge distances as the PDF payload.
  function svgShape(source, x, y, scale) {
    var w = source.width * scale, h = source.length * scale;
    function distances(c) { return [cleanNumber(c.type === 'cut' ? c.cutWidth : c.type === 'notch' ? c.notchWidth : c.type === 'radius' ? c.radius : 0) * scale, cleanNumber(c.type === 'cut' ? c.cutDepth : c.type === 'notch' ? c.notchDepth : c.type === 'radius' ? c.radius : 0) * scale]; }
    var tl = source.corners.top_left, tr = source.corners.top_right, br = source.corners.bottom_right, bl = source.corners.bottom_left;
    var a = distances(tl), b = distances(tr), c = distances(br), d = distances(bl);
    var p = 'M '+(x+a[0])+' '+y+' L '+(x+w-b[0])+' '+y;
    function corner(type, sx, sy, ex, ey, cx, cy, nx, ny) {
      return type === 'radius' ? ' Q '+cx+' '+cy+' '+ex+' '+ey : type === 'notch' ? ' L '+nx+' '+ny+' L '+ex+' '+ey : ' L '+ex+' '+ey;
    }
    p += corner(tr.type,0,0,x+w,y+b[1],x+w,y,x+w-b[0],y+b[1]);
    p += ' L '+(x+w)+' '+(y+h-c[1]);
    p += corner(br.type,0,0,x+w-c[0],y+h,x+w,y+h,x+w-c[0],y+h-c[1]);
    p += ' L '+(x+d[0])+' '+(y+h);
    p += corner(bl.type,0,0,x,y+h-d[1],x,y+h,x+d[0],y+h-d[1]);
    p += ' L '+x+' '+(y+a[1]);
    p += corner(tl.type,0,0,x+a[0],y,x,y,x+a[0],y+a[1]);
    return p+' Z';
  }
  function drawCustomerDiagrams() {
    Object.keys(state.corners).forEach(function (key) {
      var c = state.corners[key], holder = q('[data-corner="'+key+'"] [data-corner-diagram]');
      if (!holder) return;
      holder.hidden = c.type === 'square';
      if (holder.hidden) return;
      var a = cleanNumber(c.type === 'cut' ? c.cutWidth : c.type === 'notch' ? c.notchWidth : c.radius);
      var b = cleanNumber(c.type === 'cut' ? c.cutDepth : c.type === 'notch' ? c.notchDepth : c.radius);
      var scale = 95 / Math.max(a,b,1), ax = a*scale, by = b*scale;
      var right = key.indexOf('right') > -1, bottom = key.indexOf('bottom') === 0;
      var ox = right ? 230 : 80, oy = bottom ? 165 : 40, sx = right ? -1 : 1, sy = bottom ? -1 : 1;
      function pt(x,y) { return (ox+sx*x)+' '+(oy+sy*y); }
      var edge = c.type === 'radius' ? 'Q '+pt(0,0)+' '+pt(0,by) : c.type === 'notch' ? 'L '+pt(ax,by)+' L '+pt(0,by) : 'L '+pt(0,by);
      var shape = 'M '+pt(155,0)+' L '+pt(ax,0)+' '+edge+' L '+pt(0,120)+' L '+pt(155,120)+' Z';
      var aid = 'A '+fmtIn(a)+'″', bid = 'B '+fmtIn(b)+'″';
      holder.innerHTML = '<svg viewBox="0 0 310 205" role="img" aria-label="'+key.replace('_',' ')+' corner measuring diagram">'+
        '<path d="'+shape+'" fill="#e7dfd2" stroke="#655b4d" stroke-width="2"/>'+
        '<path d="M '+pt(ax,0)+' L '+pt(0,0)+' L '+pt(0,by)+'" fill="none" stroke="#6b7280" stroke-dasharray="4 4"/>'+
        '<circle cx="'+ox+'" cy="'+oy+'" r="3" fill="#1f2937"/>'+
        '<path d="M '+pt(0,-12)+' L '+pt(ax,-12)+' m '+(-sx*5)+' -4 l '+(sx*5)+' 4 l '+(-sx*5)+' 4 M '+pt(0,-12)+' l '+(sx*5)+' -4 M '+pt(0,-12)+' l '+(sx*5)+' 4" stroke="#b21e0d" fill="none" stroke-width="2"/>'+
        '<path d="M '+pt(-12,0)+' L '+pt(-12,by)+'" stroke="#1b5e87" fill="none" stroke-width="2"/>'+
        '<text x="'+(ox+sx*ax/2)+'" y="'+(oy-sy*23)+'" text-anchor="middle" fill="#b21e0d" font-size="15" font-weight="700">'+(c.type==='radius' ? 'Radius '+fmtIn(a)+'″' : aid)+'</text>'+
        '<text x="'+(ox-sx*18)+'" y="'+(oy+sy*by/2)+'" text-anchor="'+(right?'start':'end')+'" fill="#1b5e87" font-size="15" font-weight="700">'+(c.type==='radius' ? fmtIn(b)+'″' : bid)+'</text></svg>';
    });
    var review = q('[data-review-drawing]');
    if (!review) return;
    if (!(state.width > 0 && state.length > 0)) { review.textContent = 'Enter your dimensions to preview the finished shape.'; return; }
    var scale = Math.min(220/state.width,300/state.length), w = state.width*scale, h = state.length*scale, x = (340-w)/2, y = 45;
    review.innerHTML = '<svg viewBox="0 0 340 '+(h+95)+'" role="img" aria-label="Top view: '+fmtIn(state.width)+' inches wide by '+fmtIn(state.length)+' inches long">'+
      '<rect x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" fill="none" stroke="#9ca3af" stroke-dasharray="4 4"/>'+
      '<path d="'+svgShape(state,x,y,scale)+'" fill="#e7dfd2" stroke="#655b4d" stroke-width="2"/>'+
      '<text x="170" y="22" text-anchor="middle" font-size="16" font-weight="700">'+fmtIn(state.width)+'″ wide · TOP</text>'+
      '<text transform="translate(24 '+(y+h/2)+') rotate(-90)" text-anchor="middle" font-size="16" font-weight="700">'+fmtIn(state.length)+'″ long</text>'+
      '<text x="170" y="'+(y+h+30)+'" text-anchor="middle" font-size="15">BOTTOM · '+state.thickness+'″ thick</text></svg>';
    review.setAttribute('aria-label',cornerSummaryFor(state));
  }
  function validState(source, show) {
    var ok = true;
    var dimensionsOk = source.width >= 18 && source.width <= 60 && source.length >= 48 && source.length <= 80 && Number.isInteger(source.width) && Number.isInteger(source.length);
    if (show && source === state) {
      ['width', 'length'].forEach(function (key) {
        var field = q('[data-field="' + key + '"]');
        if (field) field.setAttribute('aria-invalid', dimensionsOk ? 'false' : 'true');
      });
    }
    if (!dimensionsOk) ok = false;
    var footprints = {};
    Object.keys(source.corners).forEach(function (key) {
      var corner = source.corners[key];
      var cornerOk = true;
      if (corner.type === 'cut' && (!(corner.cutWidth >= 0.5 && corner.cutWidth <= 20) || !(corner.cutDepth >= 0.5 && corner.cutDepth <= 20))) cornerOk = false;
      if (corner.type === 'radius' && !(corner.radius >= 0.5 && corner.radius <= 20)) cornerOk = false;
      if (corner.type === 'notch' && (!(corner.notchWidth >= 0.5 && corner.notchWidth <= 20) || !(corner.notchDepth >= 0.5 && corner.notchDepth <= 20))) cornerOk = false;
      var x = corner.type === 'notch' ? corner.notchWidth : (corner.type === 'square' ? 0 : (corner.type === 'radius' ? corner.radius : corner.cutWidth));
      var y = corner.type === 'notch' ? corner.notchDepth : (corner.type === 'square' ? 0 : (corner.type === 'radius' ? corner.radius : corner.cutDepth));
      footprints[key] = { x: x, y: y };
      if (show && source === state) {
        var box = root.querySelector('[data-corner="' + key + '"]');
        if (box) box.querySelectorAll('[data-corner-value]').forEach(function (input) { input.setAttribute('aria-invalid', cornerOk ? 'false' : 'true'); });
      }
      if (!cornerOk) ok = false;
    });
    var geometryOk = footprints.top_left.x + footprints.top_right.x < source.width && footprints.bottom_left.x + footprints.bottom_right.x < source.width && footprints.top_left.y + footprints.bottom_left.y < source.length && footprints.top_right.y + footprints.bottom_right.y < source.length;
    return ok && geometryOk && !!variantFor(source) && source.measurementConfirmed === true;
  }
  function setStatus(message, type) {
    status.textContent = message || '';
    status.className = 'bmp__status' + (type ? ' is-' + type : '');
  }
  function syncChoices() {
    root.querySelectorAll('.bmp__choice').forEach(function (label) {
      var input = label.querySelector('input');
      label.classList.toggle('is-selected', !!input.checked);
    });
  }
  function readFields() {
    root.querySelectorAll('[data-field]').forEach(function (field) {
      var key = field.dataset.field;
      state[key] = field.type === 'number' ? cleanNumber(field.value) : field.value;
    });
    state.quantity = Math.max(1, Math.min(10, Math.round(state.quantity || 1)));
  }
  function writeFields() {
    root.querySelectorAll('[data-field]').forEach(function (field) {
      var key = field.dataset.field;
      if (state[key] !== undefined) field.value = state[key];
    });
    var productInput = root.querySelector('input[name="bmp-product-type"][value="' + state.productType + '"]');
    if (productInput) productInput.checked = true;
    var thicknessInput = root.querySelector('input[name="bmp-thickness"][value="' + state.thickness + '"]');
    if (thicknessInput) thicknessInput.checked = true;
    Object.keys(state.corners).forEach(function (key) {
      var box = root.querySelector('[data-corner="' + key + '"]');
      var corner = state.corners[key];
      if (!box) return;
      box.querySelectorAll('[data-corner-type]').forEach(function (button) { button.classList.toggle('is-selected', button.dataset.cornerType === corner.type); });
      box.querySelectorAll('[data-corner-fields]').forEach(function (group) { group.hidden = group.dataset.cornerFields !== corner.type; });
      box.querySelectorAll('[data-corner-value]').forEach(function (input) { input.value = corner[input.dataset.cornerValue]; });
    });
    if (measurementConfirm) measurementConfirm.checked = state.measurementConfirmed === true;
  }
  function update() {
    syncChoices();
    if (measurementConfirm) measurementConfirm.checked = state.measurementConfirmed === true;
    var variant = variantFor(state);
    q('[data-summary-product]').textContent = state.productType === 'cover_only' ? 'Cover Only' : 'Mattress + Cover';
    q('[data-summary-price]').textContent = variant ? money(variant.price) : 'Unavailable';
    q('[data-summary-size]').textContent = fmtIn(state.width) + '″ × ' + fmtIn(state.length) + '″';
    q('[data-summary-thickness]').textContent = state.thickness + '″';
    q('[data-summary-corners]').textContent = cornerSummaryFor(state);
    var guidance = q('[data-thickness-help]');
    if (guidance) guidance.textContent = state.productType === 'cover_only' ? 'Cover only — no mattress core included. Match the thickness of your existing mattress.' : 'Complete mattress and removable cover. Check the maximum mattress thickness allowed for your bunk before choosing a deeper profile.';
    drawCustomerDiagrams();
    var fitmentButton = q('[data-apply-fitment]'), replaceButton = q('[data-replace-fitment]');
    if (fitmentButton) fitmentButton.textContent = savedBunks.length || draftDirty ? 'Add these bunks to my order' : 'Use these starting measurements';
    if (replaceButton) replaceButton.hidden = !savedBunks.length && !draftDirty;
    var ready = validState(state, false);
    saveBunk.disabled = !ready || !!editLineKey;
    saveBunk.hidden = !!editLineKey;
    saveBunk.textContent = editingBunkId ? 'Update saved bunk' : 'Save bunk & build another';
    cancelEdit.hidden = !editingBunkId;
    atc.disabled = !ready || !!editingBunkId;
    atc.textContent = !ready ? (state.measurementConfirmed ? 'Complete required fields' : 'Confirm measurements to continue') : (editingBunkId ? 'Update saved bunk first' : (editLineKey ? 'Update this bunk in cart' : (savedBunks.length ? 'Add only this bunk to cart' : 'Add this bunk to cart')));
    draw();
    renderOrder();
  }

  function safeStorage() { try { return window.localStorage; } catch (error) { return null; } }
  function saveOrder() {
    var storage = safeStorage();
    if (!storage) return;
    try { storage.setItem(STORAGE_KEY, JSON.stringify({ savedAt: Date.now(), bunks: savedBunks })); } catch (error) { /* storage is optional */ }
  }
  function loadOrder() {
    var storage = safeStorage();
    if (!storage) return;
    try {
      var parsed = JSON.parse(storage.getItem(STORAGE_KEY) || 'null');
      if (!parsed || !Array.isArray(parsed.bunks) || Date.now() - Number(parsed.savedAt || 0) > STORAGE_TTL_MS) {
        storage.removeItem(STORAGE_KEY);
        return;
      }
      savedBunks = parsed.bunks.slice(0, MAX_SAVED_BUNKS).map(function (item, index) {
        var bunk = shareableState(item);
        bunk.id = item.id || ('bunk-' + Date.now() + '-' + index);
        bunk.savedAt = item.savedAt || Date.now();
        return bunk;
      });
    } catch (error) { savedBunks = []; }
  }
  function renderOrder() {
    if (!orderWrap || !orderList) return;
    orderWrap.hidden = !savedBunks.length;
    if (!savedBunks.length) { orderList.innerHTML = ''; return; }
    orderList.innerHTML = '';
    var total = 0;
    var totalQuantity = 0;
    savedBunks.forEach(function (bunk, index) {
      var variant = variantFor(bunk);
      var lineTotal = variant ? variant.price * bunk.quantity : 0;
      total += lineTotal;
      totalQuantity += bunk.quantity;
      var row = document.createElement('article');
      row.className = 'bmp__saved-row' + (bunk.id === editingBunkId ? ' is-editing' : '');
      var info = document.createElement('div');
      info.className = 'bmp__saved-info';
      var title = document.createElement('strong');
      title.textContent = bunk.projectName.trim() || ('Bunk ' + (index + 1));
      var meta = document.createElement('span');
      meta.textContent = (bunk.productType === 'cover_only' ? 'Cover Only' : 'Mattress + Cover') + ' · ' + fmtIn(bunk.width) + '″ × ' + fmtIn(bunk.length) + '″ × ' + bunk.thickness + '″ · ' + cornerSummaryFor(bunk) + (bunk.quantity > 1 ? ' · Qty ' + bunk.quantity : '') + (bunk.measurementConfirmed ? ' · Measured ✓' : ' · Needs measurement confirmation');
      info.appendChild(title); info.appendChild(meta);
      var price = document.createElement('strong');
      price.className = 'bmp__saved-price';
      price.textContent = variant ? money(lineTotal) : 'Unavailable';
      var actions = document.createElement('div');
      actions.className = 'bmp__saved-actions';
      [['edit', 'Edit'], ['duplicate', 'Duplicate'], ['remove', 'Remove']].forEach(function (pair) {
        var button = document.createElement('button');
        button.type = 'button'; button.dataset.bunkAction = pair[0]; button.dataset.bunkId = bunk.id; button.textContent = pair[1];
        actions.appendChild(button);
      });
      row.appendChild(info); row.appendChild(price); row.appendChild(actions); orderList.appendChild(row);
    });
    q('[data-bunk-count]').textContent = String(savedBunks.length);
    q('[data-bunk-total]').textContent = money(total);
    var orderReady = savedBunks.every(function (bunk) { return validState(bunk, false); }) && !editingBunkId;
    addAll.disabled = !orderReady;
    addAll.textContent = orderReady ? ('Add all ' + totalQuantity + ' bunk' + (totalQuantity === 1 ? '' : 's') + ' to cart') : 'Review and confirm each bunk';
  }
  function resetForm(keepContact) {
    var contact = keepContact ? { email: state.email, rvMake: state.rvMake, rvModel: state.rvModel, rvYear: state.rvYear } : {};
    var previousType = state.productType, previousThickness = state.thickness;
    state = newState(contact);
    if (keepContact) { state.productType = previousType; state.thickness = previousThickness; }
    editingBunkId = '';
    draftDirty = false;
    writeFields();
    update();
  }
  function saveCurrentBunk() {
    readFields();
    if (!validState(state, true)) {
      setStatus('Enter valid whole-inch dimensions and review each corner before saving this bunk.', 'error');
      update();
      return;
    }
    if (!editingBunkId && savedBunks.length >= MAX_SAVED_BUNKS) {
      setStatus('This order already has 10 different bunks. Add them to the cart before starting another group.', 'error');
      return;
    }
    var entry = shareableState(state);
    entry.id = editingBunkId || ('bunk-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7));
    entry.savedAt = Date.now();
    var index = savedBunks.findIndex(function (item) { return item.id === editingBunkId; });
    var wasEditing = index > -1;
    if (wasEditing) savedBunks.splice(index, 1, entry); else savedBunks.push(entry);
    saveOrder();
    resetForm(true);
    track(wasEditing ? 'ervp_bunk_saved_updated' : 'ervp_bunk_saved', trackingDetails(entry));
    setStatus(wasEditing ? 'Saved bunk updated.' : 'Bunk saved. Build the next different bunk, or add the saved order to your cart.', 'success');
    orderWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function editSavedBunk(id) {
    var bunk = savedBunks.find(function (item) { return item.id === id; });
    if (!bunk) return;
    editingBunkId = id;
    state = normalizedState(bunk);
    draftDirty = true;
    writeFields(); update();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setStatus('Editing ' + (bunk.projectName.trim() || 'saved bunk') + '. Choose Update Saved Bunk when finished.', 'success');
  }
  function duplicateSavedBunk(id) {
    if (savedBunks.length >= MAX_SAVED_BUNKS) { setStatus('This order already has 10 different bunks.', 'error'); return; }
    var index = savedBunks.findIndex(function (item) { return item.id === id; });
    if (index < 0) return;
    var duplicate = shareableState(savedBunks[index]);
    duplicate.id = 'bunk-' + Date.now() + '-' + Math.random().toString(36).slice(2, 7);
    duplicate.savedAt = Date.now();
    if (duplicate.projectName) duplicate.projectName = (duplicate.projectName + ' Copy').slice(0, 80);
    savedBunks.splice(index + 1, 0, duplicate);
    saveOrder(); update();
    setStatus('Bunk duplicated. Edit the copy if its measurements are different.', 'success');
  }
  function removeSavedBunk(id) {
    var index = savedBunks.findIndex(function (item) { return item.id === id; });
    if (index < 0) return;
    savedBunks.splice(index, 1);
    if (editingBunkId === id) resetForm(true);
    saveOrder(); update();
    setStatus('Bunk removed from the saved order.', 'success');
  }

  function encodeShare(value) {
    var bytes = new TextEncoder().encode(JSON.stringify(value));
    var binary = '';
    bytes.forEach(function (byte) { binary += String.fromCharCode(byte); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decodeShare(value) {
    var base64 = value.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) base64 += '=';
    var binary = atob(base64);
    var bytes = new Uint8Array(binary.length);
    for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    return JSON.parse(new TextDecoder().decode(bytes));
  }
  function shareUrl() {
    readFields();
    var payload = { v: 1, createdAt: Date.now(), bunks: savedBunks.map(shareableState), draft: shareableState(state), draftDirty: draftDirty, editingIndex: savedBunks.findIndex(function (item) { return item.id === editingBunkId; }) };
    var url = new URL(window.location.origin + window.location.pathname);
    url.searchParams.set('bunk_share', encodeShare(payload));
    return url.toString();
  }
  async function copyShareLink() {
    try {
      var url = shareUrl();
      if (url.length > 16000) throw new Error('This order is too large for one share link. Add these bunks to the cart, then start a second group.');
      if (navigator.clipboard && navigator.clipboard.writeText) await navigator.clipboard.writeText(url);
      else {
        var field = document.createElement('textarea');
        field.value = url; field.setAttribute('readonly', ''); field.style.position = 'fixed'; field.style.opacity = '0';
        document.body.appendChild(field); field.select(); document.execCommand('copy'); document.body.removeChild(field);
      }
      setStatus('Share link copied. It includes the saved bunks and the unfinished build currently on screen.', 'success');
      track('ervp_bunk_share_copied', trackingDetails(state));
    } catch (error) { setStatus(error.message || 'The share link could not be copied. Please try again.', 'error'); }
  }
  function importSharedOrder() {
    var raw = new URLSearchParams(window.location.search).get('bunk_share');
    if (!raw) return false;
    try {
      var shared = decodeShare(raw);
      if (!shared || shared.v !== 1 || !Array.isArray(shared.bunks) || !shared.draft) throw new Error('Invalid shared build');
      savedBunks = shared.bunks.slice(0, MAX_SAVED_BUNKS).map(function (item, index) {
        var bunk = shareableState(item);
        bunk.id = 'shared-bunk-' + Date.now() + '-' + index;
        bunk.savedAt = Date.now();
        return bunk;
      });
      state = normalizedState(shared.draft);
      draftDirty = !!shared.draftDirty;
      var editIndex = Number(shared.editingIndex);
      if (editIndex >= 0 && savedBunks[editIndex]) editingBunkId = savedBunks[editIndex].id;
      saveOrder(); writeFields();
      setStatus('Shared bunk order loaded. Review every measurement before adding it to the cart.', 'success');
      return true;
    } catch (error) {
      setStatus('This shared bunk link could not be loaded. Ask the sender to copy a new link.', 'error');
      return false;
    }
  }

  function option(select, value, label) {
    var node = document.createElement('option');
    node.value = value; node.textContent = label; select.appendChild(node);
  }
  function unique(values) { return values.filter(function (value, index) { return values.indexOf(value) === index; }); }
  function yearLabel(fitment) { return fitment.yearStart === fitment.yearEnd ? String(fitment.yearStart) : fitment.yearStart + '–' + fitment.yearEnd; }
  function findFitment(make, handle, year) {
    return fitments.find(function (fitment) { return fitment.make === make && fitment.handle === handle && Number(year) >= fitment.yearStart && Number(year) <= fitment.yearEnd; }) || null;
  }
  function showFitmentResult(fitment, showEmpty) {
    var result = q('[data-fitment-result]'), empty = q('[data-fitment-empty]');
    selectedFitment = fitment || null;
    selectedFitmentYear = fitment ? cleanNumber(q('[data-fitment-year]').value) || fitment.yearEnd : 0;
    if (empty) empty.hidden = !!fitment || !showEmpty;
    if (!result) return;
    result.hidden = !fitment;
    if (!fitment) return;
    q('[data-fitment-result-title]').textContent = fitment.title;
    q('[data-fitment-result-summary]').textContent = fitment.bunkSummary;
    var source = q('[data-fitment-source]');
    if (source) { source.href = fitment.sourceUrl; source.textContent = 'View source floorplan'; }
  }
  function stateFromFitment(fitment, configuration) {
    var next = newState({ email: state.email, rvMake: fitment.make, rvModel: fitment.series + ' ' + fitment.model, rvYear: selectedFitmentYear || fitment.yearEnd });
    next.projectName = configuration.name;
    next.productType = state.productType;
    next.thickness = state.thickness;
    next.width = configuration.width;
    next.length = configuration.length;
    next.quantity = configuration.quantity || 1;
    next.fitmentHandle = fitment.handle;
    next.fitmentTitle = fitment.title;
    next.fitmentSourceLabel = fitment.sourceLabel;
    next.fitmentSourceUrl = fitment.sourceUrl;
    next.fitmentSuggestedWidth = configuration.width;
    next.fitmentSuggestedLength = configuration.length;
    next.measurementConfirmed = false;
    return next;
  }
  function applyFitment(fitment, quiet, replace) {
    if (!fitment || !fitment.configurations || !fitment.configurations.length) return;
    var feedback = q('[data-fitment-feedback]');
    if (editLineKey || editingBunkId) { feedback.textContent = 'Finish or cancel editing the current bunk before adding an RV floorplan.'; return; }
    if (replace && !window.confirm('Replace the saved bunks and current draft with this RV floorplan?')) return;
    var keepDraft = !replace && draftDirty;
    var nextSaved = replace ? [] : savedBunks.slice();
    if (nextSaved.length + (keepDraft ? 1 : 0) + fitment.configurations.length > MAX_SAVED_BUNKS) { feedback.textContent = 'This would exceed 10 different bunks. Add your current order to the cart before starting another group.'; return; }
    if (keepDraft) {
      var previous = shareableState(state);
      previous.id = 'draft-' + Date.now(); previous.savedAt = Date.now();
      if (!previous.projectName.trim()) previous.projectName = 'My previous bunk';
      nextSaved.push(previous);
    }
    savedBunks = nextSaved.concat(fitment.configurations.slice(1).map(function (configuration, index) {
      var bunk = stateFromFitment(fitment, configuration);
      bunk.id = 'fitment-' + Date.now() + '-' + index;
      bunk.savedAt = Date.now();
      return bunk;
    }));
    state = stateFromFitment(fitment, fitment.configurations[0]);
    editingBunkId = '';
    draftDirty = true;
    saveOrder(); writeFields(); update();
    feedback.textContent = 'Starting sizes loaded. Your other saved bunks are kept unless you chose to replace them.';
    track('ervp_bunk_fitment_applied', Object.assign(trackingDetails(state), { fitment_handle: fitment.handle, fitment_year: selectedFitmentYear || fitment.yearEnd, configuration_count: fitment.configurations.length }));
    setStatus('Published floorplan measurements loaded. Measure this exact bunk, adjust if needed, then check the confirmation box. ' + (savedBunks.length ? 'Your saved bunks are still in My Bunk Order; review any that need measurement confirmation.' : ''), 'success');
    root.querySelector('.bmp__layout').scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function initFitmentFinder() {
    var make = q('[data-fitment-make]'), model = q('[data-fitment-model]'), year = q('[data-fitment-year]');
    if (!make || !model || !year || !fitments.length) return;
    unique(fitments.map(function (fitment) { return fitment.make; })).sort().forEach(function (name) { option(make, name, name); });
    make.addEventListener('change', function () {
      model.innerHTML = '<option value="">Choose model</option>'; year.innerHTML = '<option value="">Choose year</option>';
      year.disabled = true; showFitmentResult(null, false);
      fitments.filter(function (fitment) { return fitment.make === make.value; }).sort(function (a, b) { return (a.series + a.model).localeCompare(b.series + b.model); }).forEach(function (fitment) { option(model, fitment.handle, fitment.series + ' ' + fitment.model); });
      model.disabled = !make.value;
    });
    model.addEventListener('change', function () {
      year.innerHTML = '<option value="">Choose year</option>'; showFitmentResult(null, false);
      var fitment = fitments.find(function (item) { return item.handle === model.value; });
      if (fitment) for (var value = fitment.yearEnd; value >= fitment.yearStart; value--) option(year, String(value), String(value));
      year.disabled = !fitment;
    });
    year.addEventListener('change', function () { showFitmentResult(findFitment(make.value, model.value, year.value), !!year.value); });
    q('[data-apply-fitment]').addEventListener('click', function () { applyFitment(selectedFitment, false); });
    q('[data-replace-fitment]').addEventListener('click', function () { applyFitment(selectedFitment, false, true); });

    var params = new URLSearchParams(window.location.search);
    var requestedHandle = params.get('fitment');
    if (!requestedHandle && window.location.pathname.indexOf('/pages/rv-bunk-fitment/') >= 0) requestedHandle = window.location.pathname.split('/').filter(Boolean).pop();
    var requested = fitments.find(function (fitment) { return fitment.handle === requestedHandle; });
    if (requested) {
      q('[data-fitment-finder]').open = true;
      make.value = requested.make; make.dispatchEvent(new Event('change'));
      model.value = requested.handle; model.dispatchEvent(new Event('change'));
      year.value = String(requested.yearEnd); year.dispatchEvent(new Event('change'));
      if (!savedBunks.length && !editLineKey && !params.get('bunk_share')) applyFitment(requested, true);
    }
  }

  function hydrateLegacyUpgrade() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('from') !== 'teddy-bear' || params.get('fitment') || params.get('bunk_share') || params.get('bunk_edit')) return false;
    var width = cleanNumber(params.get('width'));
    var length = cleanNumber(params.get('length'));
    var requestedThickness = cleanNumber(params.get('thickness'));
    var originalThickness = cleanNumber(params.get('legacy_thickness')) || requestedThickness;
    var supportedThicknesses = [4, 6, 8, 10];
    var thickness = supportedThicknesses.indexOf(requestedThickness) >= 0 ? requestedThickness : 4;
    if (!Number.isInteger(width) || width < 18 || width > 60 || !Number.isInteger(length) || length < 48 || length > 80) return false;
    state = newState({ email: state.email, rvMake: state.rvMake, rvModel: state.rvModel, rvYear: state.rvYear });
    state.productType = params.get('need') === 'cover' ? 'cover_only' : 'mattress_and_cover';
    state.width = width;
    state.length = length;
    state.thickness = thickness;
    state.projectName = 'Teddy Bear replacement';
    state.measurementConfirmed = false;
    draftDirty = true;
    writeFields();
    setStatus('Your Teddy Bear size is loaded as a starting point. ' + (originalThickness < 4 ? 'This builder starts at the closest available 4-inch thickness. ' : '') + 'Measure your exact bunk, adjust anything that differs, then confirm the specifications.', 'success');
    return true;
  }

  function draw() {
    if (!canvas) return;
    var ctx = canvas.getContext('2d'), W = canvas.width, H = canvas.height;
    ctx.clearRect(0, 0, W, H);
    var bg = ctx.createLinearGradient(0, 0, 0, H); bg.addColorStop(0, '#f7f4ef'); bg.addColorStop(1, '#ebe7df'); ctx.fillStyle = bg; ctx.fillRect(0, 0, W, H);
    var padX = 82, padY = 68, side = Math.max(12, Math.min(34, state.thickness * 3.1));
    var scale = Math.min((W - padX * 2) / state.width, (H - padY * 2 - side - 36) / state.length) * 0.92;
    var w = state.width * scale, h = state.length * scale, x = (W - w) / 2, y = (H - h - side) / 2 - 3;
    function dx(corner) { return Math.min((corner.type === 'notch' ? corner.notchWidth : (corner.type === 'radius' ? corner.radius : (corner.type === 'cut' ? corner.cutWidth : 0))) * scale, w); }
    function dy(corner) { return Math.min((corner.type === 'notch' ? corner.notchDepth : (corner.type === 'radius' ? corner.radius : (corner.type === 'cut' ? corner.cutDepth : 0))) * scale, h); }
    function shape(ox, oy) {
      var tl = state.corners.top_left, tr = state.corners.top_right, br = state.corners.bottom_right, bl = state.corners.bottom_left, X = x + (ox || 0), Y = y + (oy || 0);
      ctx.beginPath();
      if (tl.type === 'square') ctx.moveTo(X, Y); else if (tl.type === 'radius') { ctx.moveTo(X + dx(tl), Y); ctx.quadraticCurveTo(X, Y, X, Y + dy(tl)); } else if (tl.type === 'notch') { ctx.moveTo(X + dx(tl), Y); ctx.lineTo(X + dx(tl), Y + dy(tl)); ctx.lineTo(X, Y + dy(tl)); } else { ctx.moveTo(X + dx(tl), Y); ctx.lineTo(X, Y + dy(tl)); }
      if (bl.type === 'square') ctx.lineTo(X, Y + h); else if (bl.type === 'radius') { ctx.lineTo(X, Y + h - dy(bl)); ctx.quadraticCurveTo(X, Y + h, X + dx(bl), Y + h); } else if (bl.type === 'notch') { ctx.lineTo(X, Y + h - dy(bl)); ctx.lineTo(X + dx(bl), Y + h - dy(bl)); ctx.lineTo(X + dx(bl), Y + h); } else { ctx.lineTo(X, Y + h - dy(bl)); ctx.lineTo(X + dx(bl), Y + h); }
      if (br.type === 'square') ctx.lineTo(X + w, Y + h); else if (br.type === 'radius') { ctx.lineTo(X + w - dx(br), Y + h); ctx.quadraticCurveTo(X + w, Y + h, X + w, Y + h - dy(br)); } else if (br.type === 'notch') { ctx.lineTo(X + w - dx(br), Y + h); ctx.lineTo(X + w - dx(br), Y + h - dy(br)); ctx.lineTo(X + w, Y + h - dy(br)); } else { ctx.lineTo(X + w - dx(br), Y + h); ctx.lineTo(X + w, Y + h - dy(br)); }
      if (tr.type === 'square') ctx.lineTo(X + w, Y); else if (tr.type === 'radius') { ctx.lineTo(X + w, Y + dy(tr)); ctx.quadraticCurveTo(X + w, Y, X + w - dx(tr), Y); } else if (tr.type === 'notch') { ctx.lineTo(X + w, Y + dy(tr)); ctx.lineTo(X + w - dx(tr), Y + dy(tr)); ctx.lineTo(X + w - dx(tr), Y); } else { ctx.lineTo(X + w, Y + dy(tr)); ctx.lineTo(X + w - dx(tr), Y); }
      ctx.closePath();
    }
    ctx.save(); ctx.filter = 'blur(13px)'; ctx.globalAlpha = 0.25; ctx.fillStyle = '#665e54'; ctx.beginPath(); ctx.ellipse(W / 2, y + h + side + 10, w * 0.48, 16, 0, 0, Math.PI * 2); ctx.fill(); ctx.restore();
    shape(0, side); ctx.fillStyle = '#81776a'; ctx.fill();
    if (coverTexture.complete && coverTexture.naturalWidth) { ctx.save(); shape(0, side); ctx.clip(); ctx.globalAlpha = 0.35; ctx.drawImage(coverTexture, x, y + side, w, h); ctx.fillStyle = 'rgba(61,55,48,.28)'; ctx.fillRect(x, y + side, w, h); ctx.restore(); }
    shape(0, side); ctx.strokeStyle = '#6f665b'; ctx.lineWidth = 2; ctx.stroke();
    shape(0, 0); ctx.fillStyle = '#c8bba7'; ctx.fill(); ctx.save(); shape(0, 0); ctx.clip();
    if (coverTexture.complete && coverTexture.naturalWidth) { var pattern = ctx.createPattern(coverTexture, 'repeat'); if (pattern && pattern.setTransform && typeof DOMMatrix !== 'undefined') pattern.setTransform(new DOMMatrix().scale(0.32)); ctx.fillStyle = pattern || '#c8bba7'; ctx.fillRect(x, y, w, h); }
    var light = ctx.createLinearGradient(x, y, x + w, y + h); light.addColorStop(0, 'rgba(255,255,255,.28)'); light.addColorStop(0.48, 'rgba(255,255,255,.03)'); light.addColorStop(1, 'rgba(72,62,52,.18)'); ctx.fillStyle = light; ctx.fillRect(x, y, w, h); ctx.restore();
    shape(0, 0); ctx.strokeStyle = '#70675d'; ctx.lineWidth = 2.5; ctx.stroke(); shape(0, 0); ctx.strokeStyle = 'rgba(255,255,255,.68)'; ctx.lineWidth = 1; ctx.stroke();
    ctx.fillStyle = '#2b5f3a'; ctx.font = '700 12px sans-serif';
    Object.keys(state.corners).forEach(function (key) {
      var corner = state.corners[key];
      if (corner.type !== 'cut') return;
      var label = fmtIn(corner.cutWidth) + '″ × ' + fmtIn(corner.cutDepth) + '″';
      var lx = key.indexOf('left') >= 0 ? x + dx(corner) + 8 : x + w - dx(corner) - 8;
      var ly = key.indexOf('top') >= 0 ? y + dy(corner) + 15 : y + h - dy(corner) - 8;
      ctx.textAlign = key.indexOf('left') >= 0 ? 'left' : 'right';
      ctx.fillText(label, lx, ly);
    });
    ctx.fillStyle = '#2b5f3a'; ctx.font = '700 19px sans-serif'; ctx.textAlign = 'center'; ctx.fillText(fmtIn(state.width) + '″ wide', W / 2, y - 22); ctx.save(); ctx.translate(x - 30, y + h / 2); ctx.rotate(-Math.PI / 2); ctx.fillText(fmtIn(state.length) + '″ long', 0, 0); ctx.restore(); ctx.fillStyle = '#5f6874'; ctx.font = '600 14px sans-serif'; ctx.fillText(state.thickness + '″ thick · ' + (state.productType === 'cover_only' ? 'replacement cover' : 'mattress + cover'), W / 2, Math.min(H - 15, y + h + side + 31));
  }

  function projectPayloadFor(source) { return { id: source.projectId || undefined, name: source.projectName || 'My Bunk Project', email: source.email, rv_make: source.rvMake, rv_model: source.rvModel, rv_year: source.rvYear, product_type: source.productType, width: source.width, length: source.length, thickness: source.thickness, corners: source.corners, measurement_confirmed: source.measurementConfirmed, fitment_handle: source.fitmentHandle || undefined, fitment_title: source.fitmentTitle || undefined, fitment_source_url: source.fitmentSourceUrl || undefined }; }
  async function maybeSaveProject(source) {
    var contactOk = /.+@.+\..+/.test(String(source.email || '').trim()) && String(source.rvMake || '').trim() && String(source.rvModel || '').trim();
    if (!contactOk || source.projectId) return source;
    try {
      var endpoint = (root.dataset.backendUrl || '').replace(/\/$/, '') + '/api/bunk/projects';
      var response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(projectPayloadFor(source)) });
      if (response.ok) { var data = await response.json(); source.projectId = data.id || ''; }
    } catch (error) { /* optional project save must never block checkout */ }
    return source;
  }
  function buildSheetPayloadFor(source, variant) { return { productType: source.productType, productTitle: productConfigFor(source).title, variantId: String(variant.id).split('/').pop(), coverMaterial: 'Richloom Bunkhouse - Dune', width: source.width, length: source.length, thickness: source.thickness, quantity: source.quantity, projectName: source.projectName.trim(), rvMake: source.rvMake.trim(), rvModel: source.rvModel.trim(), rvYear: source.rvYear || undefined, corners: source.corners, measurementConfirmed: source.measurementConfirmed, fitmentHandle: source.fitmentHandle || undefined, fitmentTitle: source.fitmentTitle || undefined, fitmentSourceLabel: source.fitmentSourceLabel || undefined, fitmentSourceUrl: source.fitmentSourceUrl || undefined, fitmentSuggestedWidth: source.fitmentSuggestedWidth || undefined, fitmentSuggestedLength: source.fitmentSuggestedLength || undefined, fitmentAdjusted: !!source.fitmentHandle && (Number(source.width) !== Number(source.fitmentSuggestedWidth) || Number(source.length) !== Number(source.fitmentSuggestedLength)) }; }
  async function createBuildSheetFor(source, variant) {
    var base = (root.dataset.buildSheetApiUrl || '').replace(/\/$/, '');
    if (!base) throw new Error('Build sheet service is not configured.');
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 20000) : null;
    try {
      var response = await fetch(base + '/api/public/bunk-build-sheets', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(buildSheetPayloadFor(source, variant)), signal: controller ? controller.signal : undefined });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok || !data.buildId || !data.pdfUrl) throw new Error('We could not create the required vendor build sheet. Please retry.');
      return data;
    } finally { if (timer) clearTimeout(timer); }
  }
  function serializedStateFor(source) { return JSON.stringify(shareableState(source)); }
  function propertiesFor(source, sheet) {
    return {
      'Configuration': source.productType === 'cover_only' ? 'Cover Only' : 'Mattress + Cover',
      'Cover Material': 'Richloom Bunkhouse - Dune',
      'Exact Width': fmtIn(source.width) + '″',
      'Exact Length': fmtIn(source.length) + '″',
      'Thickness': source.thickness + '″',
      'Top-Left Corner': cornerText(source.corners.top_left),
      'Top-Right Corner': cornerText(source.corners.top_right),
      'Bottom-Left Corner': cornerText(source.corners.bottom_left),
      'Bottom-Right Corner': cornerText(source.corners.bottom_right),
      'Build ID': sheet.buildId,
      'Build Sheet PDF': sheet.pdfUrl,
      'RV Make': source.rvMake.trim(),
      'RV Model': source.rvModel.trim(),
      'RV Year': String(source.rvYear || ''),
      'Project Name': source.projectName.trim() || 'My Bunk Project',
      'Project ID': source.projectId || 'Not saved',
      'Measurements Confirmed': source.measurementConfirmed ? 'Yes' : 'No',
      'RV Fitment Guide': source.fitmentTitle || 'Manual build',
      'Fitment Starting Size': source.fitmentHandle ? fmtIn(source.fitmentSuggestedWidth) + '″ × ' + fmtIn(source.fitmentSuggestedLength) + '″' : 'Not used',
      'Fitment Adjusted': source.fitmentHandle ? ((Number(source.width) !== Number(source.fitmentSuggestedWidth) || Number(source.length) !== Number(source.fitmentSuggestedLength)) ? 'Yes' : 'No') : 'Not applicable',
      'Fitment Source': source.fitmentSourceUrl || '',
      'Builder Source': 'Bunk Mattress PDP v2',
      'Return Policy': 'Final Sale - No Returns',
      '_builder_source': 'bunk-pdp-v2',
      '_build_sheet_url': sheet.pdfUrl,
      '_builder_state': serializedStateFor(source)
    };
  }
  async function postCartItems(items, buildIds) {
    var response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
    if (!response.ok) { var error = await response.json().catch(function () { return {}; }); throw new Error(error.description || 'Cart error'); }
    await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _builder_source: 'bunk-pdp-v2', 'Built With': 'ERVP Bunk Mattress PDP', 'Bunk Build IDs': buildIds.join(', ') } }) }).catch(function () {});
  }
  async function addCurrentToCart() {
    readFields();
    if (!validState(state, true)) { setStatus('Enter valid whole-inch dimensions and review each corner before adding this custom build.', 'error'); update(); return; }
    atc.disabled = true; atc.textContent = 'Preparing build…';
    try {
      await maybeSaveProject(state);
      var variant = variantFor(state);
      if (!variant) throw new Error('No available Shopify variant matches this configuration.');
      setStatus('Creating the vendor build sheet…'); atc.textContent = 'Creating build sheet…';
      var sheet = await createBuildSheetFor(state, variant);
      atc.textContent = editLineKey ? 'Updating cart…' : 'Adding to cart…';
      await postCartItems([{ id: Number(String(variant.id).split('/').pop()), quantity: state.quantity, properties: propertiesFor(state, sheet) }], [sheet.buildId]);
      if (editLineKey) {
        var removeResponse = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: editLineKey, quantity: 0 }) });
        if (!removeResponse.ok) throw new Error('Your updated bunk was added, but the old version could not be removed automatically. Open the cart and remove the old version before checkout.');
      }
      track(editLineKey ? 'ervp_bunk_cart_updated' : 'ervp_bunk_cart_added', Object.assign(trackingDetails(state), { build_count: 1 }));
      setStatus(editLineKey ? 'Bunk updated with a new vendor sheet. Opening your cart…' : 'Custom bunk and vendor sheet saved. Opening your cart…', 'success');
      setTimeout(function () { window.location.href = '/cart'; }, 650);
    } catch (error) {
      setStatus(error.name === 'AbortError' ? 'The build sheet took too long to create. Please retry.' : (error.message || 'Unable to prepare this build. Please try again.'), 'error');
      update();
    }
  }
  async function addAllToCart() {
    if (!savedBunks.length) return;
    if (editingBunkId) { setStatus('Update or cancel the bunk you are editing before adding the saved order.', 'error'); return; }
    if (draftDirty) { setStatus('Save the unfinished bunk currently on screen before adding all saved bunks to the cart.', 'error'); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    var invalid = savedBunks.find(function (bunk) { return !validState(bunk, false); });
    if (invalid) { setStatus('One saved bunk no longer matches an available option. Edit it before adding the order.', 'error'); return; }
    addAll.disabled = true; addAll.textContent = 'Preparing build sheets…'; setStatus('Creating a separate vendor build sheet for each bunk…');
    try {
      var items = [], buildIds = [];
      for (var i = 0; i < savedBunks.length; i++) {
        var bunk = clone(savedBunks[i]);
        addAll.textContent = 'Preparing bunk ' + (i + 1) + ' of ' + savedBunks.length + '…';
        await maybeSaveProject(bunk);
        var variant = variantFor(bunk);
        var sheet = await createBuildSheetFor(bunk, variant);
        buildIds.push(sheet.buildId);
        items.push({ id: Number(String(variant.id).split('/').pop()), quantity: bunk.quantity, properties: propertiesFor(bunk, sheet) });
      }
      addAll.textContent = 'Adding all bunks…';
      await postCartItems(items, buildIds);
      track('ervp_bunk_order_cart_added', { build_count: items.length, saved_bunk_count: savedBunks.length, total_quantity: items.reduce(function (sum, item) { return sum + item.quantity; }, 0) });
      savedBunks = []; saveOrder(); renderOrder();
      setStatus('All bunks and vendor build sheets are saved. Opening your cart…', 'success');
      setTimeout(function () { window.location.href = '/cart'; }, 650);
    } catch (error) {
      addAll.disabled = false; renderOrder();
      setStatus(error.name === 'AbortError' ? 'A build sheet took too long to create. Nothing was added to the cart; please retry.' : (error.message || 'Nothing was added to the cart. Please try again.'), 'error');
    }
  }
  function hydrateCartEdit() {
    var params = new URLSearchParams(window.location.search), raw = params.get('bunk_edit');
    editLineKey = params.get('line') || '';
    if (!raw || !editLineKey) { editLineKey = ''; return false; }
    try {
      var cartState;
      try { cartState = JSON.parse(raw); }
      catch (parseError) {
        // Shopify Liquid can HTML-escape line-item property strings before URL encoding.
        // Decode one entity layer as text only; never insert customer data as HTML.
        var entities = { '&quot;': '"', '&#34;': '"', '&#39;': "'", '&#x27;': "'", '&lt;': '<', '&gt;': '>', '&amp;': '&' };
        cartState = JSON.parse(raw.replace(/&(?:quot|amp|lt|gt|#34|#39|#x27);/g, function (entity) { return entities[entity]; }));
      }
      state = normalizedState(cartState); draftDirty = true; writeFields();
      var notice = q('[data-edit-notice]'); if (notice) notice.hidden = false;
      setStatus('Your saved bunk is loaded. Make changes, then update it in the cart.', 'success');
      return true;
    } catch (error) {
      editLineKey = '';
      setStatus('We could not reload this bunk. Please rebuild it from the specifications shown in your cart.', 'error');
      return false;
    }
  }

  root.addEventListener('input', function (event) {
    if (event.target.matches('[data-field]')) {
      readFields();
      if (event.target.matches('[data-field="width"], [data-field="length"]')) state.measurementConfirmed = false;
      draftDirty = true; update();
    }
    if (event.target.matches('[data-corner-value]')) {
      var box = event.target.closest('[data-corner]'), corner = state.corners[box.dataset.corner], key = event.target.dataset.cornerValue;
      corner[key] = cleanNumber(event.target.value); state.measurementConfirmed = false; draftDirty = true; update();
    }
  });
  root.addEventListener('change', function (event) {
    if (event.target.name === 'bmp-product-type') { state.productType = event.target.value; state.measurementConfirmed = false; draftDirty = true; update(); }
    if (event.target.name === 'bmp-thickness') { state.thickness = cleanNumber(event.target.value); state.measurementConfirmed = false; draftDirty = true; update(); }
    if (event.target.matches('[data-measurement-confirm]')) {
      state.measurementConfirmed = event.target.checked; draftDirty = true; update();
      if (state.measurementConfirmed) track('ervp_bunk_measurements_confirmed', trackingDetails(state));
    }
  });
  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-technician-start]')) track('ervp_bunk_technician_start', trackingDetails(state));
    var cornerType = event.target.closest('[data-corner-type]');
    if (cornerType) {
      var box = cornerType.closest('[data-corner]'), corner = state.corners[box.dataset.corner];
      corner.type = cornerType.dataset.cornerType; state.measurementConfirmed = false;
      box.querySelectorAll('[data-corner-type]').forEach(function (button) { button.classList.toggle('is-selected', button === cornerType); });
      box.querySelectorAll('[data-corner-fields]').forEach(function (group) { group.hidden = group.dataset.cornerFields !== corner.type; });
      draftDirty = true; update(); return;
    }
    var cornerStep = event.target.closest('[data-corner-step]');
    if (cornerStep) {
      var stepBox = cornerStep.closest('[data-corner]'), stepCorner = state.corners[stepBox.dataset.corner], stepKey = cornerStep.dataset.cornerStep;
      stepCorner[stepKey] = Math.max(0.5, Math.min(20, Math.round((cleanNumber(stepCorner[stepKey]) + cleanNumber(cornerStep.dataset.step)) * 4) / 4));
      var stepInput = stepBox.querySelector('[data-corner-value="' + stepKey + '"]');
      if (stepInput) stepInput.value = stepCorner[stepKey];
      state.measurementConfirmed = false; draftDirty = true; update(); return;
    }
    var orderAction = event.target.closest('[data-bunk-action]');
    if (orderAction) {
      var id = orderAction.dataset.bunkId, action = orderAction.dataset.bunkAction;
      if (action === 'edit') editSavedBunk(id);
      if (action === 'duplicate') duplicateSavedBunk(id);
      if (action === 'remove') removeSavedBunk(id);
    }
  });
  saveBunk.addEventListener('click', saveCurrentBunk);
  cancelEdit.addEventListener('click', function () { resetForm(true); setStatus('Editing canceled. Your saved bunk was not changed.', 'success'); });
  atc.addEventListener('click', addCurrentToCart);
  addAll.addEventListener('click', addAllToCart);
  root.querySelectorAll('[data-share-bunks]').forEach(function (button) { button.addEventListener('click', copyShareLink); });
  q('[data-clear-bunks]').addEventListener('click', function () {
    if (savedBunks.length > 1 && !window.confirm('Clear all saved bunks from this order?')) return;
    savedBunks = []; saveOrder(); resetForm(true); setStatus('Saved bunk order cleared.', 'success');
  });

  coverTexture.onload = draw; coverTexture.onerror = draw; if (root.dataset.coverTextureUrl) coverTexture.src = root.dataset.coverTextureUrl;
  loadOrder();
  var restoredCartEdit = hydrateCartEdit();
  var restoredShare = restoredCartEdit ? false : importSharedOrder();
  if (!restoredCartEdit && !restoredShare) writeFields();
  initFitmentFinder();
  if (!restoredCartEdit && !restoredShare) hydrateLegacyUpgrade();
  readFields(); update();
  track('ervp_bunk_builder_view', { entry_source: restoredCartEdit ? 'cart_edit' : (restoredShare ? 'shared_build' : (new URLSearchParams(window.location.search).get('from') === 'teddy-bear' ? 'teddy_bear_upgrade' : (new URLSearchParams(window.location.search).get('fitment') ? 'fitment_page' : 'product_page'))) });
})();
